import { createAction, props } from '@ngrx/store';

import {
  RestInspectionTemplateServiceTaskOptionsModel,
  RestInspectionTemplateServiceTaskOptionsModelBase,
} from '../../shared/template-editor-dialog/interfaces/inspection-template-service-task-options.interface';

export const loadTemplateServiceTaskOptions = createAction(
  '[Template Service Task Options] Load Template Service Task Options',
  props<{ templateId: number }>()
);

export const loadTemplateServiceTaskOptionsSuccess = createAction(
  '[Template Service Task Options] Load Template Service Task Options Success',
  props<{ options: RestInspectionTemplateServiceTaskOptionsModel[] }>()
);

export const loadTemplateServiceTaskOptionsFailed = createAction(
  '[Template Service Task Options] Load Template Service Task Options Failed'
);

export const createTemplateServiceTaskOption = createAction(
  '[Template Service Task Options] Create Template Service Task Option',
  props<{ templateId: number; option: RestInspectionTemplateServiceTaskOptionsModelBase }>()
);

export const createTemplateServiceTaskOptionSuccess = createAction(
  '[Template Service Task Options] Create Template Service Task Option Success',
  props<{ option: RestInspectionTemplateServiceTaskOptionsModel }>()
);

export const createTemplateServiceTaskOptionFailed = createAction(
  '[Template Service Task Options] Create Template Service Task Option Failed'
);

export const updateTemplateServiceTaskOption = createAction(
  '[Template Service Task Options] Update Template Service Task Option',
  props<{ templateId: number; optionId: number; option: RestInspectionTemplateServiceTaskOptionsModelBase }>()
);

export const updateTemplateServiceTaskOptionSuccess = createAction(
  '[Template Service Task Options] Update Template Service Task Option Success',
  props<{ option: RestInspectionTemplateServiceTaskOptionsModel }>()
);

export const updateTemplateServiceTaskOptionFailed = createAction(
  '[Template Service Task Options] Update Template Service Task Option Failed'
);

export const deleteTemplateServiceTaskOption = createAction(
  '[Template Service Task Options] Delete Template Service Task Option',
  props<{ templateId: number; optionId: number }>()
);

export const deleteTemplateServiceTaskOptionSuccess = createAction(
  '[Template Service Task Options] Delete Template Service Task Option Success',
  props<{ optionId: number }>()
);

export const deleteTemplateServiceTaskOptionFailed = createAction(
  '[Template Service Task Options] Delete Template Service Task Option Failed'
);
